module.exports = __webpack_public_path__ + "img/toilet-paper-blank.ade41ce1.svg";